<template> 
	<div>
        <template v-if="forumTopics.length">
            <ForumSlider :forumTopics="forumTopics"/>
        </template>
		<section class="section forum">
			<div class="container">
				<div class="forum__wrapper">
					<main class="forum__main">
						<div class="forum__heading">
							<div class="forum__left">
								<h3 class="forum__title">Discussions & articles</h3>
								<h6 class="forum__title__meta">View all 
									{{ forumTopics.length }} discussions</h6>
							</div>
							<router-link
								:to="{ name: 'create-forum-post'}"
								class="btn btn__primary btn__primary--alt"
								exact>Create New Post</router-link>
						</div>
						<div class="forum__body">
							<template v-if="forumTopics && forumTopics.length">
								<div
									v-for="topic in forumTopics"
									:key="topic.id"
									:topic="topic"
									class="forum__item section__row">
									<img 
										v-if="topic.user.avatar"
										class="forum__img"
										:src="topic.user.avatar" alt="">
									<img 
										v-else
										class="forum__img"
										src="../../assets/img/profile.jpg" alt="">
									<div class="forum__details">
										<div>
											<router-link
												@click.native="setForumPost(topic)"
												:to="{
													name: 'forum-thread',
													params: {id: topic.id}
												}"
												class="forum__link">
												{{ topic.title }}
												</router-link>
											<div class="forum__meta section__row">
												<span>{{ 
													`${topic.user.fname} ${topic.user.lname}` }}
												</span>
												<span>{{ topic.created_at | date }}</span>
											</div>    
										</div>
									</div>
								</div>
							</template>	
							<template v-else>
								<p>No Topics Found</p>
							</template>
						</div>
						<Pagination 
							v-if="total > limit" 
							:options="{ limit, offset, total, baseUrl }"/>
					</main>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ForumSlider from './ForumSlider';
import Pagination from '../../components/Pagination';
import { success } from '../../utils/toast';

export default {
	name: 'Index',
	components: {
		ForumSlider,
		Pagination
	},
	data() {
		return {
			loading: '',
			forumTopics: [],
			forumsLoaded: false,
			limit: 6,
			offset: 0,
			total: 0,
			baseUrl: 'forum'
		};
	},
	computed: {
		...mapGetters([
			'fetchForumTopics',
			'getTotalTopics',
			'getForumStatus',
			'userObject'
		])
	},
	created() {
		this.listForumTopics();
		this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
		this.offset = this.$route.query.offset ? this.$route.query.offset : this.offset;
		if (this.$session.get('category') === 'employer') {
			this.$router.push('/jobs');
		}
	},
	mounted() {
		if (this.getForumStatus === 'success') {
			this.forumTopics = this.fetchForumTopics;
		}
	},
	methods: {
		...mapMutations([
			'saveForumPost'
		]),
		...mapActions([
			'getForumTopics'
		]),
		setForumPost(forumPost) {
			this.saveForumPost(forumPost);
		},
		listForumTopics() {
			this.getForumTopics([this.limit, this.offset]);
			this.forumTopics = this.fetchForumTopics;
			this.total = this.getTotalTopics;
		}
	},
	watch: {
		$route() {
			this.limit = this.$route.query.limit ? this.$route.query.limit : 0;
			this.offset = this.$route.query.offset ? this.$route.query.offset : 0;
			this.listForumTopics();
		},
		getForumStatus(val) {
			if (val === 'success') {
				this.forumTopics = this.fetchForumTopics;
			}
		}
	},
	filters: {
		date(value) {
			return moment(value).fromNow();
		}
	}
};
</script>

<style lang="scss" scoped>
.btn__primary--alt {
	display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border: none;
    font-size: 16px;
    color: #ffffff;
    border-radius: 4px;
}
</style>
